<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { ZoneStrengthDeltaZoneData } from '../../models';

const props = defineProps<DataTableCellProps<any, ZoneStrengthDeltaZoneData>>();
const { item } = toRefs(props);

const hasValue = computed(() => item.value !== null && item.value !== undefined);
const formattedValue = computed(() =>
  hasValue.value ? (props.item.data.delta > 0 ? `+${props.item.data.delta}` : props.item.data.delta.toString()) : ''
);
</script>

<template>
  <div
    class="d-flex yield-zone-strength-delta-cell align-center justify-space-between"
    v-if="hasValue">
    <span>
      {{ formattedValue }}
    </span>
    <v-icon
      class="rounded mx-2"
      v-if="item.data.delta !== 0"
      :icon="item.data.delta > 0 ? 'mdi-arrow-up-thin' : 'mdi-arrow-down-thin'"
      :color="item.data.color" />
  </div>
  <span v-else>-</span>
</template>
